import { InjectionToken } from '@angular/core';
import { KitchenService } from '../services/configurators-2d/applications/kitchen.service';

export const KI_SERVICE = new InjectionToken(typeof KitchenService);

export const kitchensProviders = [
  {
    provide: KI_SERVICE,
    useClass: KitchenService,
  },
];
